@if (formGroup) {
  <div [formGroup]="formGroup">
    <app-rich-text-control
      [fg]="formGroup"
      [formControlName]="formGroupOrControlName"
      [formGroupOrControlName]="formGroupOrControlName"
      [label]="label"
      (onBlur)="onBlurEmitter.emit($event)"
      (onFocus)="onFocusEmitter.emit($event)"
    ></app-rich-text-control>
  </div>
}
